import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { Connection, IPartnerCenterConnectionService, PartnerProfile } from '@skykick/partner-center';
import { WindowToken } from 'src/app/window';

@Injectable({
    providedIn: 'root'
})
export class PartnerCenterConnectionService extends IPartnerCenterConnectionService {
    private BaseUrl = `${environment.apis.prefix}/${environment.apis.version}`;

    constructor(
        private readonly client: HttpClient, 
        @Inject(WindowToken) private readonly window: Window
    ) { 
            super(); 
    }

    getAuthorizeUri(): Observable<string> {
        const redirectUri = `${this.window.location.origin}/callback`;
        return this.client.get<string>(this.BaseUrl + '/authorize/uri', { params: { redirectUri } });
    }

    getConnection(): Observable<Connection> {
        return this.client.get<Connection>(this.BaseUrl + '/connection');
    }

    removeConnection(): Observable<void> {
        return this.client.delete<void>(this.BaseUrl + '/connection');
    }

    saveConnection(connection: Connection): Observable<Connection> {
        return this.client.post<Connection>(this.BaseUrl + '/connection', connection);
    }

    getPartnerProfile(): Observable<PartnerProfile> {
        return this.client.get<PartnerProfile>(this.BaseUrl + '/partner/profile');
    }
}
